import JobSites from '@/apps/admin/pages/Index.vue';
import JobBoardById from '@/apps/admin/pages/JobBoardById.vue';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import { NXT_AUTH_GUARD } from '@future-harry/nxt-keycloak';
import AUTH_GUARD from '../../core/guards/auth.guard';
import TITLE_GUARD from '../../core/guards/title.guard';

import BugReportPage from '@/core/pages/BugReportPage.vue';
import ErrorPage from '@/core/pages/ErrorPage.vue';

export const routes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'JobsitesOverview',
      component: JobSites,
   },
   {
      path: '/:id',
      name: 'JobBoardById',
      component: JobBoardById,
   },
   {
      path: '/bug-report',
      name: 'BugReportPage',
      component: BugReportPage,
      meta: { titleKey: 'generic.feedback.report-bug' },
   },
   {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage,
      meta: { titleKey: 'generic.feedback.error' },
   },
];

const router = createRouter({
   history: createWebHistory(),
   routes,
});

// checking for keycloak auth first
router.beforeEach((to, from, next) => NXT_AUTH_GUARD(to, from, next));
// then check user auth and permissions
router.beforeEach(AUTH_GUARD);
router.beforeEach(TITLE_GUARD);

export default router;
